import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/tempAccount/`,
		name: "添加临时用户",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/tempAccount/`,
		name: "删除临时用户",
		delete: async function(id,data){
			return await http.delete(this.url+id+"/", data);
		}
	},
    detail: {
		url: `${config.API_URL}/tempAccount/`,
		name: "查询临时用户详情",
		get: async function(id,data){
			return await http.get(this.url+id+"/", data);
		}
	},
    list: {
		url: `${config.API_URL}/tempAccount/`,
		name: "查询临时用户列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    update: {
		url: `${config.API_URL}/tempAccount/`,
		name: "修改临时用户",
		patch: async function(id,data){
			return await http.patch(this.url+id+"/", data);
		}
	},
}
